// extracted by mini-css-extract-plugin
export default {"map-container":"CompanyMap_map-container__KfiGT"};